import { DEVELOPMENT_FLAGS, type DevelopmentFlagKey } from './developmentFlags';

export function isValidDevelopmentFlagKey(
  flagKey: string,
): flagKey is DevelopmentFlagKey {
  return flagKey in DEVELOPMENT_FLAGS;
}
